import { createContext } from 'react';
export const defaultDialogHeaderContext = {
  isDialogHeader: false
};
export const DialogHeaderContext = /*#__PURE__*/createContext(defaultDialogHeaderContext);
const {
  Provider
} = DialogHeaderContext;
export { Provider as DialogHeaderContextProvider };